import { render } from "./LzConfirmModal.vue?vue&type=template&id=deba362a"
import script from "./LzConfirmModal.vue?vue&type=script&lang=js"
export * from "./LzConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__